export default __webpack_public_path__ + "static/media/home-background.322f2f24.jpg";